/* ****************************************************************************
------------------------------ Content Toggle JS ------------------------------
**************************************************************************** */
(function($){
	
	$(document).on("click", ".btn-toggler", function(){
		$(this).parent().parent().find(".js-content-toggle").addClass('toggle-active');
		$(this).hide();
	});

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/content-toggle.js